import { Dialog, DialogTitle, DialogContent, Skeleton } from '@mui/material'
import QRCode from 'react-qr-code'
import { browserNames } from '../../../constants/form'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const QRModal = ({open, urlValue, id, handleCloseQR, handleOpen, browserInfo}) => {
	const { t } = useTranslation();

	const handleBack = () => {
		handleCloseQR()
		handleOpen()
	}

	let content = () => {
		if (id) {
			if (browserInfo.name !== browserNames.operaGX) {
				return (
					<QRCode
						size={256}
						style={{ height: "auto", maxWidth: "100%", width: "100%" }}
						value={urlValue}
						viewBox={`0 0 256 256`}
					/>
				)
			} else {
				return (
					<Alert variant='warning'>
						<p>
							{t('videoRecorder.gxMessage')}
						</p>
						<hr />
						<p className="mb-0">
							{t('videoRecorder.gxRetry')}
						</p>
					</Alert>
				)
			}
		}
		return (
			<Skeleton variant="rounded" animation="wave" width={256} height={256} />
		) 
	}

  return (
		<Dialog 
			onClose={handleCloseQR} 
			open={open}
		>
			<DialogTitle sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
				{t('videoRecorder.qrTitle')}		
			</DialogTitle>
			<DialogContent sx={{paddingBlock: 0}}>
				<div style={{ height: "auto", margin: "0 auto", maxWidth: 254, width: "100%" }}>
					{ 
						content()
					}
				</div>
			</DialogContent>
			<DialogTitle 
				onClick={handleBack}
				className='text-muted' 
				sx={{
							textAlign: 'center',
							fontSize: '14px',
							cursor: 'pointer',
							'&:hover':{
								textDecoration: 'underline'
							}
						}}
			>
				{t('videoRecorder.webOption')}
			</DialogTitle>
		
		</Dialog>
  )
}

export default QRModal